import React from 'react';
import { Dropdown, Icon } from 'semantic-ui-react';
import { connect } from 'react-redux';
import { searchUrl } from '@/constants/urls';
import paging from '@/hooks/paging';
import { fetchSearches } from '../actions';

const SavedSearchMenuItems = ({ fetchData, readStatus, searches }) => {
  paging.useFetchByCategory(fetchData, 'ribbon', readStatus);
  return (
    searches.map((search) => (
      <Dropdown.Item
        key={`searches_menu_${search.id}`}
        as="a"
        href={searchUrl(search, '#')}
        selected={false}
      >
        <Icon name="favorite" className="primary" />
        {search.name}
      </Dropdown.Item>
    ))
  );
};

const mapStateToProps = ({
  search: { searches },
}, { category }) => {
  const { results, readStatus } = searches[category];
  return ({ searches: results, readStatus });
};

const mapDispatchToProps = {
  fetchData: fetchSearches,
};

export default connect(mapStateToProps, mapDispatchToProps)(SavedSearchMenuItems);
